import ComicCard from '@/components/base/ComicCard';
import { comics } from '@/mocks/comics';

export default function LatestUpdate() {
  const sorted = [...comics].sort(
    (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
  );

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              刚刚更新的漫画章节，新鲜出炉
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
          {sorted.map((comic) => (
            <ComicCard
              key={comic.id}
              id={comic.id}
              title={comic.title}
              author={comic.author}
              cover={comic.cover}
              categoryName={comic.categoryName}
              categorySlug={comic.category}
              rating={comic.rating}
              views={comic.views}
              chapters={comic.chapters}
              status={comic.status}
              updatedAt={comic.updatedAt}
            />
          ))}
        </div>
      </div>
    </section>
  );
}